import { useEffect, useState } from 'react';
import * as S from './styles';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
//components
import LayoutDetails from '../../components/LayoutModal/LayoutDetails';
import Delete from '../../components/Delete';
//hooks
import { useMultipleModal } from '../../hooks/useMultipleModal';
//icons
import { Trash } from '@phosphor-icons/react';
//interface
import { IAttachments } from 'Interfaces/IServiceOrder';
interface IProps {
    isOpenCarousel: boolean,
    setOpenCarousel: () => void,
    attachments: IAttachments[];
    refreshData: () => void;
}

export default function CarouselModal({
    isOpenCarousel,
    setOpenCarousel,
    attachments,
    refreshData
}: IProps) {
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const { isOpenModal, toggleModalVisibility } = useMultipleModal();

    const [localAttachments, setLocalAttachments] = useState<IAttachments[]>([]);

    useEffect(() => {
        setLocalAttachments(attachments);
    }, [attachments]);

    const removeAttachmentLocally = (id: number | null) => {
        if (id) {
            setLocalAttachments(prev => prev.filter(att => att.id !== id));
            refreshData();
        }
    };

    const HandledeleteAnexo = (id: number) => {
        toggleModalVisibility("delete");
        setSelectedId(id);
    }

    if (!isOpenCarousel) return null;
    return (
        <LayoutDetails
            title="Anexos da Ordem de Serviço"
            subTitle="Veja todos os anexos disponíveis sobre a O.S."
            setModalClose={setOpenCarousel}
        >
            <S.Container>
                <Carousel
                    showThumbs={false}
                    infiniteLoop
                    useKeyboardArrows
                    autoPlay
                    interval={3000}
                    stopOnHover
                    className='carousel'
                >
                    {localAttachments.map((item, index) => {
                        const isImage = /\.(jpe?g|png|gif|webp)$/i.test(item.attachment);
                        const url = `https://homolog.clinicadeolhos.shop/storage/${item.attachment}`;

                        return (
                            <S.Content key={item.id || index}>
                                <S.Button onClick={() => HandledeleteAnexo(item.id)}>
                                    <Trash size={24} />
                                    Apagar anexo
                                </S.Button>

                                {isImage ? (
                                    <S.Image src={url} alt={`Anexo ${index + 1}`} />
                                ) : (
                                    <S.ContentPdf style={{ padding: '2rem', textAlign: 'center' }}>
                                        <a
                                            href={url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: '#007bff',
                                                textDecoration: 'underline',
                                            }}
                                        >
                                            Clique para visualizar o PDF
                                        </a>

                                        <iframe
                                            src={url}
                                            width="100%"
                                            height="500px"
                                            style={{ border: 'none', borderRadius: '8px' }}
                                            title={`PDF Preview ${index + 1}`}
                                        />
                                    </S.ContentPdf>
                                )}
                            </S.Content>
                        );
                    })}
                </Carousel>
            </S.Container>
            <Delete
                updateList={() => removeAttachmentLocally(selectedId)}
                endpoint="attachment"
                selectedProductId={selectedId}
                isOpenModal={isOpenModal("delete")}
                setModalClose={() => toggleModalVisibility("delete")}
            />
        </LayoutDetails>
    );
}
